const modalIsOpen = state => state.modals.length > 0;

export default modalIsOpen;
